import { baseDarkTheme } from '~base-theme';
import loaderTheme from './loaderTheme';
var loaderDarkTheme = {
  loader: Object.assign({}, loaderTheme.loader, {
    container: {
      backgroundColor: baseDarkTheme.base.grays.grayLighter
    },
    dash: {
      backgroundColor: baseDarkTheme.base.grays.gray
    }
  })
};
export default loaderDarkTheme;